import { computed } from 'vue';

export const useBannerData = (banner, getLocalizedText) => {
  const safeGetLocalizedText = typeof getLocalizedText === 'function'
    ? getLocalizedText
    : (text) => text || '';

  const isVisible = computed(() => {
    if (!banner?.value) return false;
    return banner.value?.desktop?.show_block ?? false;
  });

  const bannerUrl = computed(() => {
    if (!banner?.value) return '/';
    return banner.value?.desktop?.url || banner.value?.url || '/';
  });

  const bannerSrc = computed(() => {
    if (!banner?.value) return '';
    return banner.value?.desktop?.src || banner.value?.src || '';
  });

  const bannerMobileSrc = computed(() => {
    if (!banner?.value) return '';
    return banner.value?.mobile?.src || banner.value?.src || '';
  });

  const bannerTitle = computed(() => {
    if (!banner?.value) return '';
    const title = banner.value?.desktop?.name;
    return safeGetLocalizedText(title);
  });

  const bannerBtnText = computed(() => {
    if (!banner?.value) return '';
    const btnText = banner.value?.desktop?.btn_text;
    return getLocalizedText(btnText);
  });

  const bannerPriceText = computed(() => {
    if (!banner?.value) return '';
    const priceText = banner.value?.desktop?.price_text;
    if (priceText === null || priceText === undefined) return '';
    return safeGetLocalizedText(priceText);
  });

  const bannerPrice = computed(() => {
    if (!banner?.value) return null;
    const price = banner.value?.desktop?.price;
    return typeof price === 'number' ? price : null;
  });

  const bannerCrossPrice = computed(() => {
    if (!banner?.value) return null;
    const crossPrice = banner.value?.desktop?.cross_price;
    return typeof crossPrice === 'number' ? crossPrice : null;
  });

  const bannerPosition = computed(() => {
    if (!banner?.value) return 'right';
    const position = banner.value?.desktop?.position;
    return ['left', 'right'].includes(position) ? position : 'right';
  });

  const bannerBgColor = computed(() => {
    if (!banner?.value) return '#000000';
    return banner.value?.desktop?.background_color || '#000000';
  });

  const bannerFontColor = computed(() => {
    if (!banner?.value) return '#ffffff';
    return banner.value?.desktop?.font_color || '#ffffff';
  });

  const nameWidth = computed(() => {
    if (!banner?.value) return '260';
    const width = banner.value?.desktop?.name_width;
    return width ? String(width) : '260';
  });

  const buttonBgColor = computed(() => {
    if (!banner?.value) return '#ffffff';
    return banner.value?.desktop?.button_bg_color || '#ffffff';
  });

  const buttonTextColor = computed(() => {
    if (!banner?.value) return '#000000';
    return banner.value?.desktop?.button_text_color || '#000000';
  });

  const hoverEffect = computed(() => {
    if (!banner?.value) return false;
    return banner.value?.desktop?.hover_effect === true;
  });

  const textBlockStyle = computed(() => {
    try {
      return {
        backgroundColor: bannerBgColor.value,
        color: bannerFontColor.value
      };
    } catch (e) {
      return {
        backgroundColor: '#000000',
        color: '#ffffff'
      };
    }
  });

  const underButtonText = computed(() => {
    if (!banner?.value) return '';
    const text = banner.value?.desktop?.under_block_button?.under_block_btn_text || banner.value?.under_block_button?.under_block_btn_text;
    return safeGetLocalizedText(text);
  });

  const underButtonUrl = computed(() => {
    if (!banner?.value) return '/';
    return banner.value?.desktop?.under_block_button?.under_block_btn_url || banner.value?.under_block_button?.under_block_btn_url || '/';
  });

  const underButtonStyle = computed(() => {
    if (!banner?.value) return 'black';
    return banner.value?.desktop?.under_block_button?.under_block_style || banner.value?.under_block_button?.under_block_style || 'black';
  });

  const bannerContent = computed(() => {
    if (!banner?.value) return '';
    const content = banner.value?.desktop?.content ?? banner.value?.content ?? '';
    return safeGetLocalizedText(content);
  });

  const bannerMobileContent = computed(() => {
    if (!banner?.value) return '';
    const content = banner.value?.mobile?.content
      ?? banner.value?.desktop?.content
      ?? banner.value?.content
      ?? '';
    return safeGetLocalizedText(content);
  });

  const hasContentHtml = (content) => {
    if (!content) return false;
    return content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
  };

  const hasBannerContent = computed(() => hasContentHtml(bannerContent.value));
  const hasBannerMobileContent = computed(() => hasContentHtml(bannerMobileContent.value));

  return {
    isVisible,
    bannerUrl,
    bannerSrc,
    bannerMobileSrc,

    bannerTitle,
    bannerBtnText,
    bannerPriceText,

    bannerPrice,
    bannerCrossPrice,

    bannerPosition,
    bannerBgColor,
    bannerFontColor,
    nameWidth,
    buttonBgColor,
    buttonTextColor,
    textBlockStyle,
    hoverEffect,
    underButtonText,
    underButtonUrl,
    underButtonStyle,
    bannerContent,
    bannerMobileContent,
    hasBannerContent,
    hasBannerMobileContent,
  };
};
